export enum InterestAcrualType {
    Actual360 = 0,
    Thirty360 = 1,
    Actual365 = 2,
}
